import ConnectedDotCollection from "../App/ConnectedDotCollection";
import { connectedDotFromWebdotpod } from '../Infra/Webdotpod'

const webdotplates = [
  {
    "id" : "1",
    "webdotpodNames" : [
      "why-mandalart",
      "what-is-mandalart",
      "using-mandalart",
      "create-environment-with-mandala"
    ]
  },
  {
    "id" : "2",
    "webdotpodNames" : [
      "know-yourself",
      "know-how-to-live",
      "know-how-to-learn",
      "make-it-environment"
    ]
  },
  {
    "id" : "3",
    "webdotpodNames" : [
      "brain-power-is-learning-power",
      "learn-with-mandala",
      "learning-is-creation",
      "ultimate-learning"
    ]
  },
  {
    "id" : "4",
    "webdotpodNames" : [
      "shape-of-thoughts",
      "designing-thoughts",
      "what-is-design",
      "your-own-design"
    ]
  }
]

class ConnectedDotCollectionRepository {
  static all() {
    return Promise.all(
      webdotplates.map(webdotplate => {
        return Promise.all(webdotplate.webdotpodNames.map(name => connectedDotFromWebdotpod(webdotplate.id, name, name)))
        .then(connectedDotsArray => new ConnectedDotCollection(webdotplate.id, connectedDotsArray))
      })
    )
  }
}

export default ConnectedDotCollectionRepository


// WEBPACK FOOTER //
// ./src/Domain/ConnectedDotCollectionRepository.js